import type { SxProps, Theme } from '@mui/material';

export const styles = {
    paper: {
        p: { xs: 1.5, md: 3 },
        width: '100%',
        boxSizing: 'border-box',
        background: 'transparent',
        boxShadow: 'none',
        borderRadius: 0,
    } as SxProps<Theme>,
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 1,
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    dateText: { fontSize: 12, fontWeight: 300, color: 'grey.500' } as SxProps<Theme>,
    actionsRight: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 } as SxProps<Theme>,
    actionBtn: (theme: Theme) => ({
        textTransform: 'uppercase',
        fontSize: 12,
        borderRadius: 999,
        padding: '4px 16px',
        background: theme.palette.blue.main,
        color: theme.palette.white,
        fontWeight: 600,
        '&:hover': { background: theme.palette.blue[800], color: theme.palette.white },
    }),
    cancelBtn: (theme: Theme) => ({
        textTransform: 'uppercase',
        fontSize: 12,
        borderRadius: 999,
        padding: '4px 16px',
        background: theme.palette.blue.main,
        color: theme.palette.white,
        fontWeight: 600,
        ml: 1,
        '&:hover': { background: theme.palette.blue[800], color: theme.palette.white },
    }),
    declineBtn: (theme: Theme) => ({
        textTransform: 'uppercase',
        fontSize: 12,
        borderRadius: 999,
        padding: '4px 16px',
        background: theme.palette.red.main,
        color: theme.palette.white,
        fontWeight: 600,
        ml: 1,
        '&:hover': { background: theme.palette.red[800], color: theme.palette.white },
    }),
    divider: { my: 1 } as SxProps<Theme>,
    title: {
        fontSize: 20,
        fontWeight: 500,
        my: 1,
    } as SxProps<Theme>,
    metaRow: {
        display: 'flex',
        justifyContent: 'space-between',
        my: 1,
        flexWrap: 'wrap',
        gap: 1,
    } as SxProps<Theme>,
    meta: { fontSize: 12, fontWeight: 300, color: 'grey.500' } as SxProps<Theme>,
    metaVin: {
        fontSize: 12,
        fontWeight: 300,
        textTransform: 'uppercase',
        color: 'grey.500',
    } as SxProps<Theme>,
    countsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        my: 1,
    } as SxProps<Theme>,
    countsLeft: { display: 'flex', alignItems: 'center', gap: 1 } as SxProps<Theme>,
    countValue: { fontSize: 12, fontWeight: 500, color: 'grey.900' } as SxProps<Theme>,
    total: { fontSize: 14, fontWeight: 500, color: 'grey.900' } as SxProps<Theme>,
    repairersTitle: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        mt: 3,
        mb: 2,
    } as SxProps<Theme>,
    repairerCard: (theme: Theme) => ({
        background: theme.palette.grey[40],
        borderRadius: '8px',
        mb: 2,
        overflow: 'hidden',
        p: 0,
    }),
    repairerHeader: (theme: Theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2),
        gap: 1,
    }),
    repairerName: {
        fontWeight: 500,
        fontSize: 16,
        color: 'grey.900',
    } as SxProps<Theme>,
    repairerHeaderRight: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
    } as SxProps<Theme>,
    rateLink: (theme: Theme): SxProps<Theme> => ({
        color: theme.palette.blue[700],
        fontSize: 14,
        textTransform: 'none',
        gap: 0.5,
        '&:hover': { background: 'transparent', color: theme.palette.blue[800] },
    }),
    rated: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: theme.palette.blue[700],
        fontSize: 14,
    }),
    repairerTotal: { fontSize: 14, fontWeight: 500, color: 'grey.900' } as SxProps<Theme>,
    serviceItem: (theme: Theme) => ({
        padding: theme.spacing(2),
        background: theme.palette.background.paper,
        m: 1,
        borderRadius: '8px',
    }),
    serviceHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    } as SxProps<Theme>,
    serviceTitle: { fontWeight: 600, fontSize: 16 } as SxProps<Theme>,
    serviceMeta: { color: 'grey.500', fontSize: 14, fontWeight: 400 } as SxProps<Theme>,
    serviceLinkRow: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: `1px solid ${theme.palette.grey[50]}`,
        py: 1,
        mt: 1,
        cursor: 'pointer',
    }),
    serviceLink: (theme: Theme): SxProps<Theme> => ({
        textTransform: 'uppercase',
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.blue[700],
    }),
};
